import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DeckList } from '../../../features/decks/deck-list';

/**
 * `?q=` URL param feeds DeckList's title filter. AuthTopbar's always-visible search
 * input writes to it, so the deck list filtering survives reloads + deep links.
 *
 * `?create=deck|folder` is set by AuthTopbar's `<CreatePicker>` (next to avatar) —
 * DeckList opens the corresponding modal when the param is present and clears it on close.
 * URL-driven modals: shareable + browser-back closes the modal naturally.
 */
const decksSearchSchema = z.object({
  q: z.string().optional(),
  create: z.enum(['deck', 'folder']).optional(),
  folder: z.coerce.number().int().positive().optional(),
});

export const Route = createFileRoute('/_auth/decks/')({
  validateSearch: decksSearchSchema,
  component: DeckList,
});
